const { SubscriptionTypes } = require('./subscriptionTypes');
const { CreatedFromEnum } = require('./createdFromEnum');
const { PriorityCategoriesEnum } = require('./priorityCategoriesEnum');
const { set, get, head, find } = require('lodash');

const typeIconMapper = [
    {
        isForwarded: true,
        subscriptionType: SubscriptionTypes.Priority,
        icon: 'icon-icons8-circled_d',
    },
    {
        isForwarded: false,
        subscriptionType: SubscriptionTypes.Turn,
        icon: 'icon-icons8-circled_c',
    },
    {
        isForwarded: false,
        subscriptionType: SubscriptionTypes.Normal,
        icon: 'icon-icons8-circled_e',
    },
    {
        isForwarded: false,
        subscriptionType: SubscriptionTypes.Priority,
        icon: 'icon-icons8-circled_e',
    },
];

const priorityIconMapper = [
    {
        createdFrom: CreatedFromEnum.totemOperator,
        subscriptionType: SubscriptionTypes.Priority,
        priorityCategory: PriorityCategoriesEnum.Generic,
        icon: 'icon-accessible',
    },
    {
        createdFrom: CreatedFromEnum.operator,
        subscriptionType: SubscriptionTypes.Priority,
        priorityCategory: PriorityCategoriesEnum.Disabled,
        icon: `icon-${PriorityCategoriesEnum.Disabled}`,
    },
    {
        createdFrom: CreatedFromEnum.operator,
        subscriptionType: SubscriptionTypes.Priority,
        priorityCategory: PriorityCategoriesEnum.Pregnant,
        icon: `icon-${PriorityCategoriesEnum.Pregnant}`,
    },
    {
        createdFrom: CreatedFromEnum.operator,
        subscriptionType: SubscriptionTypes.Priority,
        priorityCategory: PriorityCategoriesEnum.Elderly,
        icon: `icon-${PriorityCategoriesEnum.Elderly}`,
    },
];

const setTypeIcon = (subscription) => {
    const isForwarded = get(head(get(subscription, 'movementsHistory', [])), 'action', '') === 'forward';

    set(
        subscription,
        'subscriptionTypeIcon',
        get(
            find(
                typeIconMapper,
                {
                    isForwarded,
                    subscriptionType: subscription.subscriptionType
                }
            ),
            'icon',
            ''
        ) || ''
    );
};

const setPriorityIcon = (subscription) => {
    const priorityCategory = get(subscription, 'person.priority.category', '');

    set(
        subscription,
        'subscriptionPriorityIcon',
        get(
            find(
                priorityIconMapper,
                {
                    priorityCategory,
                    subscriptionType: subscription.subscriptionType,
                    createdFrom: subscription.createdFrom,
                }
            ),
            'icon',
            ''
        ) || ''
    );
};

module.exports = {
    setTypeIcon,
    setPriorityIcon,
};